/* eslint max-len: 0 */

import {
  KILOMETERS,
  MILES,
  FEET,
  YARDS,
  METERS,
  KILOCALORIES,
  KILOJOULES,
  JOULES,
  SECONDS,
  MINUTES,
  HOURS,
  DAYS,
  WEEKS,
  MONTHS,
  YEARS,
  KNOTS,
  FEET_PER_SECOND,
  MILES_PER_HOUR,
  KILOMETERS_PER_HOUR,
  METERS_PER_SECOND,
  MINUTE_KM,
  MINUTE_MI,
  SECOND_MI,
  SECOND_KM,
} from './constants'

export default {

  // distance
  [FEET]: { [YARDS]: 1 / 3, [METERS]: 0.3048, [KILOMETERS]: 0.0003048, [MILES]: 1 / 5280 },
  [YARDS]: { [FEET]: 3, [METERS]: 0.9144, [KILOMETERS]: 0.000914400292608, [MILES]: 1 / 1760 },
  [METERS]: { [FEET]: 3.28083989, [YARDS]: 1.093613298, [KILOMETERS]: 1 / 1000, [MILES]: 0.000621371192 },
  [KILOMETERS]: { [FEET]: 3280.84, [YARDS]: 1093.61, [METERS]: 1000, [MILES]: 0.621371192 },
  [MILES]: { [FEET]: 5280, [YARDS]: 1760, [METERS]: 1609.34, [KILOMETERS]: 1.6093440 },

  // duration
  [SECONDS]: { [MINUTES]: 1 / 60, [HOURS]: 1 / 3600, [DAYS]: 1 / 86400, [WEEKS]: 1 / 604800, [MONTHS]: 1 / 2678400, [YEARS]: 1 / 31536000 },
  [MINUTES]: { [SECONDS]: 60, [HOURS]: 1 / 60, [DAYS]: 1 / 1440, [WEEKS]: 1 / 10080, [MONTHS]: 1 / 43200, [YEARS]: 1 / 525600 },
  [HOURS]: { [SECONDS]: 3600, [MINUTES]: 60, [DAYS]: 1 / 24, [WEEKS]: 1 / 84, [MONTHS]: 1 / 720, [YEARS]: 1 / 8760 },
  [DAYS]: { [SECONDS]: 86400, [MINUTES]: 1440, [HOURS]: 24, [YEARS]: 1 / 365, [WEEKS]: 1 / 7, [MONTHS]: 1 / 31, [YEARS]: 1 / 365 },
  [WEEKS]: { [SECONDS]: 604800, [MINUTES]: 10080, [HOURS]: 84, [MONTHS]: 1 / 4, [DAYS]: 7, [YEARS]: 1 / 52 },
  [MONTHS]: { [SECONDS]: 2678400, [MINUTES]: 43200, [HOURS]: 720, [DAYS]: 31, [WEEKS]: 4, [YEARS]: 1 / 12 },
  [YEARS]: { [SECONDS]: 31536000, [MINUTES]: 525600, [HOURS]: 8760, [DAYS]: 365, [WEEKS]: 52, [MONTHS]: 12 },

  // energy
  [KILOCALORIES]: { [KILOJOULES]: 4.184, [JOULES]: 4184 },
  [KILOJOULES]: { [KILOCALORIES]: 0.239006, [JOULES]: 1000 },
  [JOULES]: { [KILOCALORIES]: 0.000239006, [KILOJOULES]: 0.001 },

  [METERS_PER_SECOND]: {
    [KILOMETERS_PER_HOUR]: 3.6,
    [MILES_PER_HOUR]: 2.236936,
    [KNOTS]: 1.943844,
    [FEET_PER_SECOND]: 3.2808399,
    [MINUTE_MI]: n => 26.8224 / n,
    [MINUTE_KM]: n => 16.666666667 / n,
    [SECOND_MI]: n => 1609.344 / n,
    [SECOND_KM]: n => 1000 / n,
  },

  [KILOMETERS_PER_HOUR]: {
    [METERS_PER_SECOND]: 0.277778,
    [MILES_PER_HOUR]: 0.621371,
    [KNOTS]: 0.539957,
    [FEET_PER_SECOND]: 0.911344,
    [SECOND_KM]: n => 3600 / n,
  },

  [MILES_PER_HOUR]: {
    [METERS_PER_SECOND]: 0.44704,
    [KILOMETERS_PER_HOUR]: 1.609344,
    [KNOTS]: 0.868976,
    [FEET_PER_SECOND]: 1.466667,
    [SECOND_MI]: n => 3600 / n,
  },

  [KNOTS]: { [METERS_PER_SECOND]: 0.514444, [KILOMETERS_PER_HOUR]: 1.852, [MILES_PER_HOUR]: 1.150779, [FEET_PER_SECOND]: 1.687810 },
  [FEET_PER_SECOND]: { [METERS_PER_SECOND]: 0.3048, [KILOMETERS_PER_HOUR]: 1.09728, [MILES_PER_HOUR]: 0.681818, [KNOTS]: 0.592484 },

  [MINUTE_KM]: { [MINUTE_MI]: 1.60934, [METERS_PER_SECOND]: n => 16.666666667 / n },
  [MINUTE_MI]: { [MINUTE_KM]: 0.621371, [METERS_PER_SECOND]: n => 26.8224 / n },
  [SECOND_KM]: { [MINUTE_KM]: 1 / 60, [METERS_PER_SECOND]: n => 1000 / n },
  [SECOND_MI]: { [MINUTE_MI]: 1 / 60, [METERS_PER_SECOND]: n => 1609.344 / n },

}



// WEBPACK FOOTER //
// ./src/shared/units/conversionTable.js